import axios from 'axios'
import router from '@/router/index'
import qs from "qs";
import {
	MessageBox,Message
} from 'element-ui'
import store from '@/store'
import {
	getToken
} from "./app"
// 创建axios实例
const service = axios.create({
	// axios中请求配置有baseURL选项，表示请求URL公共部分
	baseURL: process.env.VUE_APP_BASE_API,
	// 超时
	//timeout: 10000
})
// request拦截器
service.interceptors.request.use(
	config => {
		config.headers.Authentication = getToken();
		config.headers['content-type'] = 'application/json';
		// if (config.qs != undefined) {
		// 	config.data = qs.stringify(config.data, config.qs); //config.qs是对应api.js里面参数用于 实体类里面实体数组参数接受
		// } else {
		// 	config.data = qs.stringify(config.data, {
		// 		arrayFormat: 'repeat' //处理 后台接收数组参数
		// 	}); //qs处理
		// }
		return config
	},
	error => {
		console.log(error)
		Promise.reject(error)
	}
)

// 添加响应拦截器
service.interceptors.response.use(function(response) {
	if(response.config.downbinary){
		return response;
	}
	if (response.data.code == 401) {
		MessageBox.confirm(
			'登录状态已过期，您可以继续留在该页面，或者重新登录',
			'系统提示', {
				confirmButtonText: '重新登录',
				cancelButtonText: '取消',
				type: 'warning'
			}
		).then(() => {
			store.dispatch('user/LogOut').then(() => {
				window.location.reload(); // 为了重新实例化vue-router对象 避免bug
			})
		})
		//response.data.msg = '身份失效，请重新登录!' //token 不正确 提示语言
	} else if (response.data.code == 0){
		return response;
	}else{
		if(response.config.url.indexOf('inquiry/exportWord')<0){	// 导出word返回的数据没有有data.code
			Message.error(response.data.msg || '系统错误，请联系管理员');
		}
		return response;
	}
}, function(error) {
	return Promise.reject(error);
});

export default service
